import ValidationForm from '../components/shared/validation/ValidationForm.vue'
import ValidationField from '../components/shared/validation/ValidationField.vue'

// Form doğrulama (Aşama 2.2; vee 3.4.14'ün yerine). Kurallar utils/validationRules.js'te.
export default {
  install(app) {
    app.component('ValidationForm', ValidationForm)
    app.component('ValidationField', ValidationField)
  }
}
